// The approved schedule uses fixed CET (UTC+1), independent of the visitor's timezone.
export function isLiveChatWithinOperatingHours(date: Date = new Date()): boolean {
  const cetDate = new Date(date.getTime() + 60 * 60 * 1000);
  const day = cetDate.getUTCDay();
  const hour = cetDate.getUTCHours();

  return day >= 1 && day <= 5 && hour >= 8 && hour < 18;
}
